import type { AdvantagesProps } from '@/components/landing-page/components/advantages';

export const defaults: Required<AdvantagesProps> = {
  title: 'Vorteile beim Einspruch mit SOS Verkehrsrecht',
  list: [
    'Größte Verkehrsrechtskanzlei in Deutschland',
    'Erfahrung aus über 150.000 Mandate',
    'Einfach und unkompliziert',
    'Sofortige Hilfe',
    'Deutschlandweit tätig',
  ],
  withImage: false,
  withoutButton: false,
};
